<template>
  <ion-fab slot="fixed" horizontal="end" vertical="bottom">
    <ion-fab-button>{{ selectLang }}</ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button @click="changeLang('zh-CN')">{{ $t('yy_zh') }}</ion-fab-button>
      <ion-fab-button @click="changeLang('en-US')">{{ $t('yy_en') }}</ion-fab-button>
      <ion-fab-button @click="changeLang('sp-ES')">{{ $t('yy_sp') }}</ion-fab-button>
    </ion-fab-list>
  </ion-fab>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { IonFab, IonFabButton, IonFabList } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { setLanguage } from '@/i18n';

const { locale, t } = useI18n();
const selectLang = computed(() => {
  return locale.value === 'zh-CN'
    ? t('yy_zh')
    : locale.value === 'en-US'
      ? t('yy_en')
      : locale.value === 'sp-ES'
        ? t('yy_sp')
        : '';
});
const changeLang = (lang: string) => {
  setLanguage(lang);
};
</script>
<style scoped>
ion-fab-button {
  --background: #7adfde;
  --background-activated: #22bbb3;
  --background-hover: #22bbb3;
  /* --border-radius: 15px; */
  --box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3),
    0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  --color: #333;
}
</style>
